export const JOB_STATUS_ACTIVE = "active";
export const JOB_STATUS_INACTIVE = "inactive";

export const JOB_PART_TIME = { label: "Part Time", value: "part-time" };
export const JOB_FULL_TIME = { label: "Full Time", value: "full-time" };

export const JOB_MIN_SALARY = "min";
export const JOB_MAX_SALARY = "max";

export const JOB_STATUS_COMPLETED = "completed";
export const JOB_STATUS_PROCESSING = "processing";
export const JOB_STATUS_INITIALIZING = "initializing";
export const JOB_STATUS_REQUEST_REVIEW = "request_review";
export const JOB_STATUS_FAILED = "failed";

export const JOB_STATUS_MAP: Record<string, string> = {
  [JOB_STATUS_PROCESSING]: "In Progress",
  [JOB_STATUS_INITIALIZING]: "In Progress.",
  [JOB_STATUS_REQUEST_REVIEW]: "In Progress..",
  [JOB_STATUS_FAILED]: "Job Failed",
};

export const JOB_STATUS_RESULT_MAP: Record<string, string> = {
  [JOB_STATUS_PROCESSING]: "Processing",
  [JOB_STATUS_INITIALIZING]: "Processing.",
  [JOB_STATUS_REQUEST_REVIEW]: "Processing..",
  [JOB_STATUS_FAILED]: "Job Failed",
};
